const SOURCETREEAPP_VANITY_DOMAIN = "sourcetreeapp.com";

/**
 * `sourcetreeapp.com` and `www.sourcetreeapp.com` only.
 *
 * Other `*.sourcetreeapp.com` subdomains are not matched; use a path that includes the
 * `sourcetreeapp` segment on the request host instead (e.g.
 * `wac.stg.internal.atlassian.com/sourcetreeapp`).
 */
export function isSourcetreeHostname(hostname: string | undefined): boolean {
    if (!hostname) {
        return false;
    }
    const host = hostname.toLowerCase();
    return (
        host === SOURCETREEAPP_VANITY_DOMAIN ||
        host === `www.${SOURCETREEAPP_VANITY_DOMAIN}`
    );
}
